import React from 'react';
import MkPhone from '../MkPhone';
import MkPill from '../MkPill';
import bmbActivity from '../../../assets/images/mk/mk-bmb-activity-540.webp';
import bmbActivity2x from '../../../assets/images/mk/mk-bmb-activity-740.webp';
import bmbHeatmap from '../../../assets/images/mk/mk-bmb-heatmap-540.webp';
import bmbHeatmap2x from '../../../assets/images/mk/mk-bmb-heatmap-740.webp';

// B5 — insights and mindful-break reminders. The two Leaderboard screens carry the section: per-app activity
// (left, hidden on phones so the front screen stays legible) and the heatmap + insights (front).
const BmbPatterns = () => (
  <section className="mk-patterns section" id="patterns" aria-labelledby="mk-patterns-title">
    <div className="container">
      <div className="mk-patterns__inner section-inner">
        <div className="mk-patterns__visual reveal-scale-up">
          <div className="mk-patterns__stack">
            <div className="mk-patterns__phone mk-patterns__phone--back">
              <MkPhone
                src={bmbActivity}
                srcSet={`${bmbActivity} 540w, ${bmbActivity2x} 740w`}
                sizes="210px"
                width={540}
                height={1095}
                framed
                alt="Bring Me Back App Activity for the last 7 days, listing pauses, skips and opens for each app"
              />
            </div>
            <div className="mk-patterns__phone mk-patterns__phone--front">
              <MkPhone
                src={bmbHeatmap}
                srcSet={`${bmbHeatmap} 540w, ${bmbHeatmap2x} 740w`}
                sizes="(max-width: 640px) 240px, 210px"
                width={540}
                height={1095}
                framed
                alt="Bring Me Back Activity Heatmap of pauses by hour and day, with screen time and personalized insights"
              />
            </div>
          </div>
        </div>
        <div className="mk-patterns__text">
          <div className="mk-head mk-head--left reveal-from-bottom">
            <h2 id="mk-patterns-title" className="mk-h2">
              See when the urge hits
            </h2>
          </div>
          <div className="mk-patterns__list">
            <div className="mk-patterns__item reveal-from-bottom" data-reveal-delay="0">
              <h3 className="mk-h3">
                <MkPill variant="free">Free</MkPill>
              </h3>
              <p className="mk-body">Your daily streak and today's pauses.</p>
            </div>
            <div className="mk-patterns__item reveal-from-bottom" data-reveal-delay="80">
              <h3 className="mk-h3">
                <MkPill variant="premium">Premium</MkPill>
              </h3>
              <p className="mk-body">
                7- and 30-day history with usage charts, an activity heatmap showing when pauses happen by hour and day, and
                personalized insights — like which pause works best for each app.
              </p>
            </div>
            <div className="mk-patterns__item reveal-from-bottom" data-reveal-delay="160">
              <h3 className="mk-h3">
                Mindful-break reminders <MkPill variant="premium">Premium</MkPill>
              </h3>
              <p className="mk-body">
                Get a reminder to take a mindful pause at the times and days you choose — on iPhone and Android.
              </p>
            </div>
          </div>
          <p className="mk-micro mk-patterns__micro">
            On iPhone, app time counts only the time after a pause, not your full Screen Time.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default BmbPatterns;
